import { navigateToTeamsApp } from '@atlaskit/teams-app-config/navigation';

import { COMPANY_HUB } from '@confluence/named-routes/entry-points/routes';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { isTeamsAppEnabled } from '@confluence/teams-app-config/entry-points/isTeamsAppEnabled';

export const useFallbackUrls = (): Record<string, string> => {
	const { cloudId, orgId } = useSessionData();
	const { href } = navigateToTeamsApp({
		type: 'LANDING',
		cloudId,
		orgId,
		userHasNav4Enabled: true,
	});
	return {
		companyHubShortcut: COMPANY_HUB.toUrl(),
		teamsShortcut: isTeamsAppEnabled() ? href : '',
	};
};
